import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UtilsService } from 'core/utils/utils.service';
import { DashboardService } from '../../services/dashboard.service';
import { LnOrder } from '../../entities/ln-order';
import { TrackingInfo } from '../../entities/tracking-info';
import { TrackingNumbersComponent } from '../tracking-numbers/tracking-numbers.component';

@Component({
  selector: 'app-ln-orders',
  templateUrl: './ln-orders.component.html',
  styleUrls: ['./ln-orders.component.scss'],
  standalone: false
})
export class LnOrdersComponent implements OnInit, OnChanges {
  @Input() accountManagerEmployeeId: string;
  @Input() isShipped: boolean;
  @Input() isVisible: boolean;
  @ViewChild('ordersTable') ordersTable: ElementRef;

  appStrings: AppLocalization;
  dateFormat: string;
  displayedColumns = [
    'customerName',
    'bpNumber',
    'lnOrderNumber',
    'orderDate',
    'amount',
    'poNumber',
    'trackingNumber',
    'view'
  ];

  displayedColumnsShipped = [
    'customerName',
    'bpNumber',
    'lnOrderNumber',
    'shipDate',
    'amount',
    'poNumber',
    'trackingNumber',
    'view'
  ];

  lnOrders: LnOrder[] = [];
  loading = true;
  noResults = false;

  constructor(
    private appInfoService: AppInfoService,
    private dialog: MatDialog,
    private dashboardService: DashboardService,
    private router: Router,
    private utilsService: UtilsService,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.dateFormat = this.appInfoService.dateFormat;
    if (this.isShipped) {
      this.getLNShippedOrders();
    } else {
      this.getLNOpenOrders();
    }
  }


  ngOnChanges(changes: SimpleChanges) {
    const amChange = changes.accountManagerEmployeeId;
    if (amChange?.previousValue && amChange.previousValue !== amChange.currentValue) {
      if (this.isShipped) {
        this.getLNShippedOrders(false);
      } else {
        this.getLNOpenOrders(false);
      }
    }
  }

  /**
   * Redirecting to quote details page
   * @param quote quote id
   */
  goToOrderDetails(order: LnOrder) {
    this.router.navigate(['ln-orders', order.orderNumber]);
  }


  /**
   *Getting LN open orders for a specific account manager
   */
  getLNOpenOrders(scrollIntoView = true) {
    if (this.accountManagerEmployeeId) {
      this.loading = true;
      this.dashboardService.getLNOpenOrders(this.accountManagerEmployeeId).subscribe((orders: LnOrder[]) => {
        this.lnOrders = orders;
        this.noResults = orders.length === 0;
        this.loading = false;
        if (this.isVisible && scrollIntoView) {
          setTimeout(() => {
            this.scrollIntoView();
          });
        }
      });
    }
  }

  /**
   *Getting LN shipped orders for a specific account manager
   */
  getLNShippedOrders(scrollIntoView = true) {
    if (this.accountManagerEmployeeId) {
      this.loading = true;
      this.dashboardService.getLNShippedOrders(this.accountManagerEmployeeId).subscribe((orders: LnOrder[]) => {
        this.lnOrders = orders;
        this.noResults = orders.length === 0;
        this.loading = false;
        if (this.isVisible && scrollIntoView) {
          setTimeout(() => {
            this.scrollIntoView();
          });
        }
      });
    }
  }

  /**
   * Opens tracking and carrier information popup
   * @param orderTrackingList tracking numbers list
   * @param orderNumber order number
   */
  displayTrackingDialog(orderTrackingList: TrackingInfo[], orderNumber: string) {
    this.dialog.open(TrackingNumbersComponent, {
      panelClass: ['ds', 'fullWidth', this.deviceService.isMobile() ? 'fullScreen' : ''],
      data: {
        orderTrackingList,
        orderNumber
      }
    });
  }

  private scrollIntoView() {
    this.utilsService.scrollToElement(this.ordersTable.nativeElement, 145);
  }
}
